/* Email popup: after sign-up, reopen the popup with the code showing and keep it open until "Copy Code" is tapped. */
(function () {
  var KEY = 'bsPopupSubmitted';
  function q(sel, root) { return (root || document).querySelector(sel); }

  function init() {
    var root = q('[class^="ai-email-popup-"][data-delay]');
    if (!root) return;
    var overlay = q('[class^="ai-email-popup-overlay-"]', root);
    var reveal = q('[class^="ai-email-popup-code-reveal-"]', root);
    var copyBtn = q('[class^="ai-email-popup-copy-button-"]', root);
    var closeBtn = q('[class^="ai-email-popup-close-"]', root);
    var form = q('form', root);
    var success = q('[class^="ai-email-popup-success-"]', root);
    if (!overlay || !reveal || !copyBtn) return;

    var locked = false;
    var hint = null;

    if (form) {
      form.addEventListener('submit', function () {
        try { sessionStorage.setItem(KEY, '1'); } catch (e) {}
      });
    }

    var submitted = false;
    try { submitted = sessionStorage.getItem(KEY) === '1'; } catch (e) {}

    if (success && submitted) {
      try { sessionStorage.removeItem(KEY); } catch (e) {}

      var fields = root.querySelectorAll('input[type="email"], button[type="submit"]');
      for (var i = 0; i < fields.length; i++) fields[i].style.display = 'none';

      overlay.classList.add('active');
      reveal.classList.add('active');
      document.body.style.overflow = 'hidden';

      locked = true;
      if (closeBtn) closeBtn.style.visibility = 'hidden';

      hint = document.createElement('div');
      hint.textContent = 'Tap "Copy Code" to save your code before continuing.';
      hint.style.cssText = 'margin-top:10px;font-size:13px;opacity:.85;';
      reveal.appendChild(hint);
    }

    function unlock() {
      if (!locked) return;
      locked = false;
      if (closeBtn) closeBtn.style.visibility = '';
      if (hint) hint.textContent = 'Code copied! You can close this window now.';
    }

    copyBtn.addEventListener('click', function () {
      if (!navigator.clipboard) {
        var t = document.createElement('textarea');
        t.value = copyBtn.getAttribute('data-code') || '';
        t.setAttribute('readonly', '');
        t.style.position = 'fixed';
        t.style.opacity = '0';
        document.body.appendChild(t);
        t.select();
        try { document.execCommand('copy'); } catch (e) {}
        document.body.removeChild(t);
        copyBtn.textContent = 'Copied!';
      }
      unlock();
    });

    document.addEventListener('click', function (e) {
      if (!locked) return;
      if ((closeBtn && closeBtn.contains(e.target)) || e.target === overlay) {
        e.stopImmediatePropagation();
        e.preventDefault();
      }
    }, true);

    window.addEventListener('keydown', function (e) {
      if (locked && e.key === 'Escape') {
        e.stopImmediatePropagation();
        e.preventDefault();
      }
    }, true);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
